import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/app/App';
import '@/styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento raiz da aplicacao nao encontrado.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
